var _ellipse, _circle, _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgMenuIcon6(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _ellipse || (_ellipse = /*#__PURE__*/React.createElement("ellipse", {
    cx: 10,
    cy: 17.5,
    rx: 7,
    ry: 3.5,
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7,
    r: 4,
    stroke: "#3C7795",
    strokeWidth: 1.5,
    strokeLinejoin: "round"
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15.3408 4.26562C17.2524 4.43755 18.7509 6.04374 18.751 8C18.751 10.0709 17.0719 11.7498 15.001 11.75C14.6094 11.75 14.2318 11.6894 13.877 11.5781C14.3287 11.1953 14.7218 10.7465 15.0439 10.2471C16.2665 10.2239 17.251 9.22814 17.251 8C17.2509 7.07941 16.6972 6.28874 15.9053 5.94043C15.7995 5.34729 15.6072 4.7847 15.3408 4.26562Z",
    fill: "#3C7795"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M15.752 13.2695C17.192 13.3409 18.5093 13.6133 19.5312 14.0391C20.1281 14.2878 20.6604 14.6029 21.0547 14.9912C21.4516 15.3823 21.7499 15.8927 21.75 16.499C21.75 17.1053 21.4516 17.6158 21.0547 18.0068C20.6604 18.3951 20.128 18.7103 19.5312 18.959C19.2139 19.0912 18.8672 19.2071 18.498 19.3086C18.8122 18.7578 18.9873 18.1685 18.9971 17.5537C19.4625 17.3552 19.7956 17.1408 20.002 16.9375C20.2119 16.7306 20.25 16.5829 20.25 16.499C20.2499 16.4151 20.2119 16.2674 20.002 16.0605C19.7891 15.8509 19.4426 15.6274 18.9541 15.4238C18.7068 15.3208 18.4318 15.2268 18.1338 15.1436C17.5694 14.4171 16.7526 13.7783 15.752 13.2695Z",
    fill: "#3C7795"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgMenuIcon6);
export default __webpack_public_path__ + "static/media/Menu Icon (6).06861ed7998e1aa925788aa122818229.svg";
export { ForwardRef as ReactComponent };